import * as yup from 'yup';

// Helpers/utils
const email = yup.string().email('Email must be a valid email.').required('Email is required.');

// Validation objects
export const loginValidation = yup.object().shape({
  email,
  password: yup.string().required('Password is required.'),
});

export const forgotPasswordValidation = yup.object().shape({
  email,
});
